import { yupResolver } from '@hookform/resolvers/yup';
import { useNotifications } from '@toolpad/core';
import { useForm } from 'react-hook-form';
import { TextFieldElement } from 'react-hook-form-mui';
import * as Yup from 'yup';
import { Box, Stack, Typography } from '@mui/material';

import { Link, Logo } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Authentication } from '@barboxx/models';

import {
    Footer,
    RootContainer,
    StyledForm,
    SubmitButton,
} from '../StyledComponents';

const FORGOT_PASSWORD_SCHEMA = Yup.object().shape({
    email: Yup.string()
        .email('Must match and email address')
        .required('Required'),
});

export default function ForgotPassword() {
    const notifications = useNotifications();

    const formContext = useForm<Authentication.ForgotPasswordRequest>({
        resolver: yupResolver(FORGOT_PASSWORD_SCHEMA),
    });

    console.log('form context', formContext);

    const onSubmit = (values: Authentication.ForgotPasswordRequest) =>
        Api.Authentication.Users.forgotPassword(values)
            .then(response => {
                if (response.ok) {
                    notifications.show('Sent reset password to your email', {
                        severity: 'success',
                    });
                } else {
                    throw response.data;
                }
            })
            .catch((error: Error) => {
                notifications.show(error.message, {
                    severity: 'error',
                });
            });

    return (
        <RootContainer maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
            >
                <Logo />
                <Typography
                    margin={2}
                    variant="h6"
                    align="center"
                    color="textPrimary"
                >
                    Business Portal
                </Typography>

                <StyledForm onSuccess={onSubmit}>
                    <Stack gap={2}>
                        <TextFieldElement
                            label="Email"
                            name="email"
                            fullWidth
                            required
                            autoComplete="email"
                            autoFocus
                        />
                        <SubmitButton
                            type="submit"
                            color="primary"
                            variant="contained"
                            fullWidth
                            loading={formContext.formState.isSubmitting}
                        >
                            Reset Password
                        </SubmitButton>
                    </Stack>
                </StyledForm>

                <Link
                    marginTop={1}
                    alignSelf="flex-end"
                    color="textSecondary"
                    to="/login"
                >
                    Go back to sign in?
                </Link>
                <Footer>
                    <Typography color="textPrimary" variant="body2">
                        <Link to="/signup">Sign up</Link> for barboxx business
                        portal!
                    </Typography>
                </Footer>
            </Box>
        </RootContainer>
    );
}
